import { LevelInfoPayload } from "@/app/ui/controllers/MembershipFormulaController";
import { CreateLoyaltyProgramMembershipFormulaInterface, UpdateMembershipFormulaRequestInterface } from "../contracts/MembershipFormulaRequest"

export interface MembershipFormulaLevelInfo {
  id?: number
  multiplier?: number
}

export class UpdateMembershipFormulaApiRequest
  implements UpdateMembershipFormulaRequestInterface {
  private channel?: string;
  private nominal?: number | string;
  private is_sender?: boolean;
  private is_receiver?: boolean;
  private level_info?: Array<LevelInfoPayload>;
  private start_date?: string;
  private end_date?: string;

  constructor(
    channel?: string,
    nominal?: number | string,
    is_sender?: boolean,
    is_receiver?: boolean,
    level_info?: Array<LevelInfoPayload>,
    start_date?: string,
    end_date?: string,
  ) {
    this.channel = channel;
    this.nominal = nominal;
    this.is_sender = is_sender;
    this.is_receiver = is_receiver;
    this.level_info = level_info;
    this.start_date = start_date;
    this.end_date = end_date;
  }

  public toPayload(): string {
    return JSON.stringify({
      channel: this.channel,
      nominal: this.nominal,
      is_sender: this.is_sender,
      is_receiver: this.is_receiver,
      level_info: this.level_info,
      start_date: this.start_date,
      end_date: this.end_date,
    })
  }
}

export class CreateLoyaltyProgramMembershipFormula implements CreateLoyaltyProgramMembershipFormulaInterface {
  private readonly channel?: string
  private readonly nominal?: number | string
  private readonly is_sender?: boolean
  private readonly is_receiver?: boolean
  private readonly level_info?: Array<MembershipFormulaLevelInfo>
  private readonly start_date?: string
  private readonly end_date?: string

  constructor(
    channel?: string,
    nominal?: number | string,
    isSender?: boolean,
    isReceiver?: boolean,
    levelInfo?: Array<MembershipFormulaLevelInfo>,
    startDate?: string,
    endDate?: string
  ) {
    this.channel = channel
    this.nominal = nominal
    this.is_sender= isSender
    this.is_receiver = isReceiver
    this.level_info = levelInfo
    this.start_date = startDate
    this.end_date = endDate
  }
  toPayload(): string {
      return JSON.stringify({
        channel: this.channel,
        nominal: this.nominal,
        is_sender: this.is_sender,
        is_receiver: this.is_receiver,
        level_info: this.level_info,
        start_date: this.start_date,
        end_date: this.end_date
      })
  }
}
